<template>
	<section ref="bookerTarget" class="hero">
		<div class="hero__container">
			<div class="hero__main-gradient"></div>
			<div class="hero__gradient"></div>
			<div class="hero__container-inner">
				<!-- <GlobalImage class="hero__image" src="homepage-hero2-v2.webp" loading="eager" fetchpriority="high" :lazyLoad="false" :height="1160" />
			<GlobalImage
				class="hero__image-mobile"
				src="homepage-hero2-mobile-v2.webp"
				loading="eager"
				fetchpriority="high"
				:lazyLoad="false"
				:height="485" /> -->
				<h1 class="hero__title">
					<template v-if="$te('modules.home_page_module.home_page_hero.nationwide')">
						<span class="hero__title-part">{{ $t('modules.home_page_module.home_page_hero.nationwide') }}</span>
						{{ ' ' }}
					</template>
					<span class="hero__title-part">{{ $t('modules.home_page_module.home_page_hero.car_rental') }}</span>
				</h1>
				<!-- <GlobalImage
				class="hero__image hero__image--mask"
				loading="eager"
				fetchpriority="high"
				:lazyLoad="false"
				src="homepage-hero-mask-v2.png"
				:height="1160" />
			<GlobalImage
				class="hero__image hero__image--mask-big"
				loading="eager"
				fetchpriority="high"
				:lazyLoad="false"
				src="homepage-hero-mask-big-v3.png"
				:height="1160" />
			<GlobalImage
				class="hero__image-mobile hero__image-mobile--mask"
				loading="eager"
				fetchpriority="high"
				:lazyLoad="false"
				src="homepage-hero-mobile-mask-v2.png"
				:height="265" /> -->
				<div ref="bookerContainerRef" class="hero__booker-container">
					<div class="hero__days-months-google-container">
						<GlobalBookerDaysMonths />
						<div class="hero__reviews-container">
							<LazyIdleGlobalBookerGoogleReviews hydrate-on-idle />
							<LazyIdleGlobalBookerTrustpilotReviews hydrate-on-idle />
						</div>
					</div>
					<div class="hero__global-booker-wrapper" :style="{ minHeight: bookerHeight ? `${bookerHeight}px !important` : 'unset' }">
						<GlobalBookerFallback>
							<ClientOnly>
								<LazyGlobalBooker v-if="!isNavBookerVisible" />
							</ClientOnly>
						</GlobalBookerFallback>
					</div>
				</div>
				<div :key="reloadAdvantages" className="advantages-wrapper">
					<LazyIdleGlobalBookerAdvantages hydrate-on-idle />
				</div>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
const bookerTarget = inject<HTMLElement>('bookerTarget')
const isNavBookerVisible = inject<Ref<boolean>>('isNavBookerVisible')
const bookerHeight = ref()
const reloadAdvantages = ref(0)

const bookerContainerRef = ref<HTMLElement | null>(null)

onMounted(() => {
	reloadAdvantages.value++

	requestAnimationFrame(() => {
		const globalBooker = document.querySelector('.hero__global-booker-wrapper')
		if (globalBooker) {
			bookerHeight.value = globalBooker.clientHeight
		}
	})

	setTimeout(() => {
		if (bookerContainerRef.value) {
			bookerContainerRef.value.style.transform = 'none'
		}
	}, 250)
})
</script>

<style scoped lang="scss" src="./HomePageHero.scss"></style>
<style scoped lang="scss">
.advantages-wrapper {
	@media (max-width: $bp-laptop) {
		min-height: 149px;
	}
}
</style>
